import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '常赢三兄弟'
          }
        },{
          path: '/product',
          name: 'product',
          component: resolve => require(['@/view/Product'], resolve),
          meta: {
            title: '常赢三兄弟-产品介绍'
          }
        },{
          path: '/atore',
          name: 'atore',
          component: resolve => require(['@/view/Store'], resolve),
          meta: {
            title: '常赢三兄弟-门店分布'
          }
        },{
          path: '/joinus',
          name: 'joinus',
          component: resolve => require(['@/view/JoinUs'], resolve),
          meta: {
            title: '常赢三兄弟-品质加盟'
          }
        },{
          path: '/aboutus',
          name: 'aboutus',
          component: resolve => require(['@/view/AboutUs'], resolve),
          meta: {
            title: '常赢三兄弟-关于我们'
          }
        }, {
          path: '/brand',
          name: 'brand',
          component: resolve => require(['@/view/CompanyBrand'], resolve),
          meta: {
            title: '常赢三兄弟-品牌介绍'
          }
        }, {
          path: '/subbrand',
          name: 'subbrand',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '常赢三兄弟-'
          }
        },{
          path: '/subbranddetail',
          name: 'subbranddetail',
          component: resolve => require(['@/view/SubCompany'], resolve),
          meta: {
            title: '常赢三兄弟-'
          }
        },  {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '常赢三兄弟-联系我们'
          }
        }
      ]
    }
  ],
  mode: 'history',
  // 解决路由跳转后，不显示在首行
  scrollBehavior() {
    return {x: 0, y: 0};
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js